import { HEX } from "../../../src/actions/hex-patterns";
import { Targeting } from "../../../src/actions/targeting";
import { SEC } from "../../../src/time-utils";
const inspire = {
  slug: "inspire",
  name: "Inspire",
  description: "Rally your allies with a rousing performance",
  abilityIcon: "inspire",
  costs: [
    { stat: "mana", value: 18 }
  ],
  targeting: Targeting.MeleeAttack,
  cooldown: SEC(8),
  impactSchedule: {
    [0]: [
      {
        hexes: HEX.CIRCLE_3,
        effect: {
          statChanges: [
            {
              stat: "health",
              direction: "loss",
              scalingFactors: {}
            }
          ],
          addConditions: [
            {
              slug: "inspired",
              name: "Inspired",
              tags: ["buff"]
            }
          ],
          removeConditionsByTag: []
        }
      }
    ]
  },
  tags: ["spell", "buff", "gold", "aoe"]
};
export {
  inspire
};
//# sourceMappingURL=data:application/json;base64,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
